import React from 'react';
import styles from './legal.module.scss';

type Props = {
    children: string,
};

export const Legal: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <div className={styles.legal}>
            {props.children}
        </div>
    );
};
